var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-select-input',{attrs:{"label":"User","options":_vm.options},model:{value:(_vm.proxy),callback:function ($$v) {_vm.proxy=$$v},expression:"proxy"}})}
var staticRenderFns = []

export { render, staticRenderFns }